const removeUSA = (input: string) => input?.replace(', USA', '');


export default removeUSA;